export class ActiveFixedAssigSerialEntity {
   
    id: number;
    assigmentId: number;
    productfeaturId: number;
    serial: String;

    constructor () {}
}